import { useEffect } from 'react';

import { useAppSelector } from '@/App/hooks';
import { selectLocale } from '@/features/i18n/selectLocale';

export const useSetDocumentLanguage = () => {
  const locale = useAppSelector(selectLocale);

  useEffect(() => {
    if (locale) {
      document.documentElement.lang = locale;
    }
  }, [locale]);
};
